import { render, staticRenderFns } from "./RedResultsDataTable.vue?vue&type=template&id=657d3bce"
import script from "./RedResultsDataTable.vue?vue&type=script&lang=js"
export * from "./RedResultsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports